import { render } from "./About.vue?vue&type=template&id=9e552aa4"
const script = {}
script.render = render

export default script